import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { reduxForm, Field, getFormValues } from "redux-form";
import ContentCard from "../common/template/contentCard";
import ContentCardBody from "../common/template/contentCardBody";
import ContentCardFooter from "../common/template/contentCardFooter";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import Button from "../common/button/button";
import Form from "../common/form/form";
import LabelAndInput from "../common/form/labelAndInput";
import LabelAndInputMask from "../common/form/labelAndInputMask";

import { setModoTela, initForm } from "./empresaActions";
import LabelAndCheckbox from "../common/form/labelAndCheckbox";

class EmpresaForm extends Component {
    render() {
        const readOnly = this.props.excluir || this.props.visualizar ? "readOnly" : "";
        const menuAnaliseMarcado =
            !!this.props.formularioValues.acesso_modulo_analise &&
            (this.props.formularioValues.acesso_modulo_analise_custo ||
                this.props.formularioValues.acesso_modulo_analise_consumo ||
                this.props.formularioValues.acesso_modulo_analise_tarifa ||
                this.props.formularioValues.acesso_modulo_analise_aproveitamento_consumo_horario ||
                this.props.formularioValues.acesso_modulo_analise_demanda ||
                this.props.formularioValues.acesso_modulo_analise_multa ||
                this.props.formularioValues.acesso_modulo_analise_micro_mini_geracao ||
                this.props.formularioValues.acesso_modulo_analise_empenho ||
                this.props.formularioValues.acesso_modulo_analise_devolucao ||
                this.props.formularioValues.acesso_modulo_analise_mercado_livre ||
                this.props.formularioValues.acesso_modulo_analise_contrato_aluguel_usina ||
                this.props.formularioValues.acesso_modulo_analise_reativo);

        return (
            <>
                <ContentCard>
                    <Form event={this.props.handleSubmit}>
                        <Row>
                            <Grid cols="12 12 12 12">
                                <ContentCardBody>
                                    <Row>
                                        <Field name="nome" component={LabelAndInput} label="Nome" placeholder="Informe o nome" cols="12 12 12 12" readOnly={readOnly} />
                                    </Row>
                                    <Row style={{ paddingBottom: 20 }}>
                                        <Field
                                            name="cnpj"
                                            component={LabelAndInputMask}
                                            label="CNPJ"
                                            placeholder="Informe o CNPJ"
                                            cols="12 12 12 12"
                                            mask="99.999.999/9999-99"
                                            readOnly={readOnly}
                                        />
                                    </Row>
                                    <ContentCardBody style={{ backgroundColor: "#EFEFEF", borderRadius: 10 }}>
                                        <Row>
                                            <h6 style={{ margin: 20 }}>Itens Acessíveis do Menu:</h6>
                                        </Row>
                                        <Row>
                                            <Grid cols="12 12 12 3">
                                                <Grid cols="12 12 12 12">
                                                    <h5 style={{ margin: 10, fontSize: "1.0rem", textDecoration: "underline" }}>Geral</h5>
                                                </Grid>
                                                <Field name="acesso_modulo_dashboard" component={LabelAndCheckbox} label="Tela Inicial" cols="12 12 12 12" readOnly={readOnly} />
                                                <Field name="acesso_modulo_usuario" component={LabelAndCheckbox} label="Usuário" cols="12 12 12 12" readOnly={readOnly} />
                                                <Field name="acesso_modulo_fatura_cliente" component={LabelAndCheckbox} label="Faturas" cols="12 12 12 12" readOnly={readOnly} />
                                                <Field
                                                    name="acesso_modulo_fatura_relatorio"
                                                    component={LabelAndCheckbox}
                                                    label="Relatório"
                                                    cols="12 12 12 12"
                                                    readOnly={readOnly}
                                                />

                                                <Field
                                                    name="acesso_modulo_gestao_credito_solar"
                                                    component={LabelAndCheckbox}
                                                    label="Gestão Crédito Solar"
                                                    cols="12 12 12 12"
                                                    readOnly={readOnly}
                                                />
                                                <Field
                                                    name="acesso_modulo_diagnostico_energia"
                                                    component={LabelAndCheckbox}
                                                    label="Diagnóstico de Energia"
                                                    cols="12 12 12 12"
                                                    readOnly={readOnly}
                                                />
                                                <Field
                                                    name="acesso_modulo_redes_eletricas"
                                                    component={LabelAndCheckbox}
                                                    label="Redes Elétricas"
                                                    cols="12 12 12 12"
                                                    readOnly={readOnly}
                                                />
                                                <Field
                                                    name="acesso_modulo_documento_cliente"
                                                    component={LabelAndCheckbox}
                                                    label="Documentos do Cliente"
                                                    cols="12 12 12 12"
                                                    readOnly={readOnly}
                                                />
                                                <Field
                                                    name="acesso_modulo_geracao_leitura"
                                                    component={LabelAndCheckbox}
                                                    label="Monitoramento Solar"
                                                    cols="12 12 12 12"
                                                    readOnly={readOnly}
                                                />
                                                <Field
                                                    name="acesso_modulo_monitoramento_consumo"
                                                    component={LabelAndCheckbox}
                                                    label="Monitoramento de Consumo"
                                                    cols="12 12 12 12"
                                                    readOnly={readOnly}
                                                />
                                            </Grid>
                                            <Grid cols="12 12 12 3">
                                                <Grid cols="12 12 12 12">
                                                    <h5 style={{ margin: 10, fontSize: "1.0rem", textDecoration: "underline" }}>Cadastro</h5>
                                                </Grid>
                                                <Field name="acesso_modulo_cliente" component={LabelAndCheckbox} label="Cliente" cols="12 12 12 12" readOnly={readOnly} />
                                                <Field
                                                    name="acesso_modulo_concessionaria"
                                                    component={LabelAndCheckbox}
                                                    label="Concessionária"
                                                    cols="12 12 12 12"
                                                    readOnly={readOnly}
                                                />
                                                <Field
                                                    name="acesso_modulo_plataforma_mercado_livre"
                                                    component={LabelAndCheckbox}
                                                    label="Plataforma de Mercado Livre"
                                                    cols="12 12 12 12"
                                                    readOnly={readOnly}
                                                />
                                                <Field
                                                    name="acesso_modulo_gestor_concessionaria"
                                                    component={LabelAndCheckbox}
                                                    label="Gestor de Concessionária"
                                                    cols="12 12 12 12"
                                                    readOnly={readOnly}
                                                />
                                                <Field
                                                    name="acesso_modulo_empenho"
                                                    component={LabelAndCheckbox}
                                                    label="Empenho (prefeituras)"
                                                    cols="12 12 12 12"
                                                    readOnly={readOnly}
                                                />
                                                <Field
                                                    name="acesso_modulo_documento"
                                                    component={LabelAndCheckbox}
                                                    label="Anexar Documentos"
                                                    cols="12 12 12 12"
                                                    readOnly={readOnly}
                                                />
                                                <Field
                                                    name="acesso_modulo_demanda_contrato"
                                                    component={LabelAndCheckbox}
                                                    label="Contrato de Demanda"
                                                    cols="12 12 12 12"
                                                    readOnly={readOnly}
                                                />
                                                <Field
                                                    name="acesso_modulo_contrato_mercado_livre"
                                                    component={LabelAndCheckbox}
                                                    label="Contrato de Mercado Livre"
                                                    cols="12 12 12 12"
                                                    readOnly={readOnly}
                                                />
                                                <Field
                                                    name="acesso_modulo_contrato_aluguel"
                                                    component={LabelAndCheckbox}
                                                    label="Contrato de Aluguel de Usina"
                                                    cols="12 12 12 12"
                                                    readOnly={readOnly}
                                                />
                                                <Field
                                                    name="acesso_modulo_geracao"
                                                    component={LabelAndCheckbox}
                                                    label="Micro e Mini Gerador"
                                                    cols="12 12 12 12"
                                                    readOnly={readOnly}
                                                />
                                                <Field
                                                    name="acesso_modulo_geracao_integracao"
                                                    component={LabelAndCheckbox}
                                                    label="Integração Geração"
                                                    cols="12 12 12 12"
                                                    readOnly={readOnly}
                                                />
                                                <Field
                                                    name="acesso_modulo_consumo_integracao"
                                                    component={LabelAndCheckbox}
                                                    label="Integração Consumo"
                                                    cols="12 12 12 12"
                                                    readOnly={readOnly}
                                                />
                                                <Field name="acesso_modulo_rede" component={LabelAndCheckbox} label="Rede Elétrica" cols="12 12 12 12" readOnly={readOnly} />
                                                <Field name="acesso_modulo_tributacao" component={LabelAndCheckbox} label="Tributação" cols="12 12 12 12" readOnly={readOnly} />
                                            </Grid>
                                            <Grid cols="12 12 12 3">
                                                <Grid cols="12 12 12 12">
                                                    <h5 style={{ margin: 10, fontSize: "1.0rem", textDecoration: "underline" }}>ADM (Eficience)</h5>
                                                </Grid>
                                                <Field name="acesso_modulo_fatura" component={LabelAndCheckbox} label="Fatura" cols="12 12 12 12" readOnly={readOnly} />
                                                <Field
                                                    name="acesso_modulo_gestao_tarefa"
                                                    component={LabelAndCheckbox}
                                                    label="Gestão de Tarefa"
                                                    cols="12 12 12 12"
                                                    readOnly={readOnly}
                                                />
                                                <Field
                                                    name="acesso_modulo_documento_adm"
                                                    component={LabelAndCheckbox}
                                                    label="Documento ADM"
                                                    cols="12 12 12 12"
                                                    readOnly={readOnly}
                                                />
                                                <Grid cols="12 12 12 12" style={{ marginTop: 20 }}>
                                                    <h5 style={{ margin: 10, fontSize: "1.0rem", textDecoration: "underline" }}>Verificador de Faturas</h5>
                                                </Grid>
                                                <Field
                                                    name="acesso_modulo_fatura_engenharia"
                                                    component={LabelAndCheckbox}
                                                    label="Fatura Engenharia"
                                                    cols="12 12 12 12"
                                                    readOnly={readOnly}
                                                />
                                                <Field
                                                    name="acesso_modulo_verificador_icms_energia"
                                                    component={LabelAndCheckbox}
                                                    label="Verificador ICMS Energia"
                                                    cols="12 12 12 12"
                                                    readOnly={readOnly}
                                                />
                                                <Field
                                                    name="acesso_modulo_verificador_consumo_agua"
                                                    component={LabelAndCheckbox}
                                                    label="Verificador Consumo Água"
                                                    cols="12 12 12 12"
                                                    readOnly={readOnly}
                                                />
                                            </Grid>
                                            <Grid cols="12 12 12 3">
                                                <Grid cols="12 12 12 12">
                                                    <h5 style={{ margin: 10, fontSize: "1.0rem", textDecoration: "underline" }}>Análise</h5>
                                                </Grid>
                                                <LabelAndCheckbox
                                                    name="acesso_modulo_analise"
                                                    label="Menu - Análise"
                                                    cols="12 12 12 12"
                                                    readOnly={readOnly}
                                                    value={menuAnaliseMarcado}
                                                    onChange={() => {
                                                        this.props.initForm({
                                                            ...this.props.formularioValues,
                                                            acesso_modulo_analise: !this.props.formularioValues.acesso_modulo_analise,
                                                            acesso_modulo_analise_custo: !this.props.formularioValues.acesso_modulo_analise,
                                                            acesso_modulo_analise_consumo: !this.props.formularioValues.acesso_modulo_analise,
                                                            acesso_modulo_analise_tarifa: !this.props.formularioValues.acesso_modulo_analise,
                                                            acesso_modulo_analise_aproveitamento_consumo_horario: !this.props.formularioValues.acesso_modulo_analise,
                                                            acesso_modulo_analise_demanda: !this.props.formularioValues.acesso_modulo_analise,
                                                            acesso_modulo_analise_multa: !this.props.formularioValues.acesso_modulo_analise,
                                                            acesso_modulo_analise_micro_mini_geracao: !this.props.formularioValues.acesso_modulo_analise,
                                                            acesso_modulo_analise_empenho: !this.props.formularioValues.acesso_modulo_analise,
                                                            acesso_modulo_analise_devolucao: !this.props.formularioValues.acesso_modulo_analise,
                                                            acesso_modulo_analise_mercado_livre: !this.props.formularioValues.acesso_modulo_analise,
                                                            acesso_modulo_analise_contrato_aluguel_usina: !this.props.formularioValues.acesso_modulo_analise,
                                                            acesso_modulo_analise_reativo: !this.props.formularioValues.acesso_modulo_analise,
                                                        });
                                                    }}
                                                />
                                                <Field
                                                    name="acesso_modulo_analise_custo"
                                                    component={LabelAndCheckbox}
                                                    label="Aba - Análise de Custo"
                                                    cols="12 12 12 12"
                                                    readOnly={readOnly || !menuAnaliseMarcado}
                                                />
                                                <Field
                                                    name="acesso_modulo_analise_consumo"
                                                    component={LabelAndCheckbox}
                                                    label="Aba - Análise de Consumo"
                                                    cols="12 12 12 12"
                                                    readOnly={readOnly || !menuAnaliseMarcado}
                                                />
                                                <Field
                                                    name="acesso_modulo_analise_tarifa"
                                                    component={LabelAndCheckbox}
                                                    label="Aba - Análise de Tarifas"
                                                    cols="12 12 12 12"
                                                    readOnly={readOnly || !menuAnaliseMarcado}
                                                />
                                                <Field
                                                    name="acesso_modulo_analise_aproveitamento_consumo_horario"
                                                    component={LabelAndCheckbox}
                                                    label="Aba - Análise de Aproveitamento de Consumo Horário"
                                                    cols="12 12 12 12"
                                                    readOnly={readOnly || !menuAnaliseMarcado}
                                                />
                                                <Field
                                                    name="acesso_modulo_analise_demanda"
                                                    component={LabelAndCheckbox}
                                                    label="Aba - Análise de Demanda"
                                                    cols="12 12 12 12"
                                                    readOnly={readOnly || !menuAnaliseMarcado}
                                                />
                                                <Field
                                                    name="acesso_modulo_analise_reativo"
                                                    component={LabelAndCheckbox}
                                                    label="Aba - Análise de Reativos"
                                                    cols="12 12 12 12"
                                                    readOnly={readOnly || !menuAnaliseMarcado}
                                                />
                                                <Field
                                                    name="acesso_modulo_analise_multa"
                                                    component={LabelAndCheckbox}
                                                    label="Aba - Análise de Multas"
                                                    cols="12 12 12 12"
                                                    readOnly={readOnly || !menuAnaliseMarcado}
                                                />
                                                <Field
                                                    name="acesso_modulo_analise_micro_mini_geracao"
                                                    component={LabelAndCheckbox}
                                                    label="Aba - Análise de Micro/Mini Geração"
                                                    cols="12 12 12 12"
                                                    readOnly={readOnly || !menuAnaliseMarcado}
                                                />
                                                <Field
                                                    name="acesso_modulo_analise_empenho"
                                                    component={LabelAndCheckbox}
                                                    label="Aba - Análise/Gestão de Empenho"
                                                    cols="12 12 12 12"
                                                    readOnly={readOnly || !menuAnaliseMarcado}
                                                />
                                                <Field
                                                    name="acesso_modulo_analise_devolucao"
                                                    component={LabelAndCheckbox}
                                                    label="Aba - Análise de Devoluções/Ressarcimentos"
                                                    cols="12 12 12 12"
                                                    readOnly={readOnly || !menuAnaliseMarcado}
                                                />
                                                <Field
                                                    name="acesso_modulo_analise_mercado_livre"
                                                    component={LabelAndCheckbox}
                                                    label="Aba -  Análise de Mercado Livre"
                                                    cols="12 12 12 12"
                                                    readOnly={readOnly || !menuAnaliseMarcado}
                                                />
                                                <Field
                                                    name="acesso_modulo_analise_contrato_aluguel_usina"
                                                    component={LabelAndCheckbox}
                                                    label="Aba - Análise de Contrato de Aluguel de Usina"
                                                    cols="12 12 12 12"
                                                    readOnly={readOnly || !menuAnaliseMarcado}
                                                />
                                            </Grid>
                                        </Row>
                                    </ContentCardBody>
                                </ContentCardBody>
                            </Grid>
                        </Row>
                        <ContentCardFooter>
                            <Row alignCenter>
                                <Grid cols="6 6 4 3">
                                    {this.props.excluir ? (
                                        <Button
                                            text="Excluir"
                                            submit
                                            type={"danger"}
                                            icon={"fa fa-trash"}
                                            disabled={!this.props.usuarioLogado.administrador || this.props.usuarioLogado.id_cliente || this.props.usuarioLogado.id_empresa}
                                        />
                                    ) : (
                                        <Button
                                            text={"Salvar"}
                                            submit
                                            type={"success"}
                                            icon={"fa fa-check"}
                                            disabled={
                                                !this.props.usuarioLogado.administrador ||
                                                this.props.usuarioLogado.id_cliente ||
                                                this.props.usuarioLogado.id_empresa ||
                                                this.props.visualizar
                                            }
                                        />
                                    )}
                                </Grid>
                                <Grid cols="6 6 4 3">
                                    <Button text="Voltar" type={"warning"} icon={"fa fa-chevron-left"} event={() => this.props.setModoTela("lista")} />
                                </Grid>
                            </Row>
                        </ContentCardFooter>
                    </Form>
                </ContentCard>
            </>
        );
    }
}

EmpresaForm = reduxForm({
    form: "empresaForm",
    destroyOnUnmount: false,
})(EmpresaForm);
const mapStateToProps = (state) => ({
    sessao: state.auth.usuario,
    usuarioLogado: state.auth.usuarioLogado,
    formularioValues: getFormValues("empresaForm")(state),
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setModoTela,
            initForm,
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(EmpresaForm);
